export default __webpack_public_path__ + "static/media/1_redsys.fa7bd771.svg";